import React from 'react'

export default function Footer() {
  return (
    <div class="footer">
    Unable to scan your documents?<br/>Call xxx-xxx-xxxx Ext-xxx or contact at cs@companyemail.com <br/>Copyright © 2024
    </div>
  )
}
